import { render, staticRenderFns } from "./DashboardConversation.vue?vue&type=template&id=e013726e&scoped=true&lang=pug"
import script from "./DashboardConversation.vue?vue&type=script&lang=js"
export * from "./DashboardConversation.vue?vue&type=script&lang=js"
import style0 from "./DashboardConversation.vue?vue&type=style&index=0&id=e013726e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e013726e",
  null
  
)

export default component.exports